export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/voucher/HomeView.vue'),
  },
  {
    meta: { title: 'menu.docs' },
    path: '/docs',
    name: 'docs',
    component: async () => await import('@/views/voucher/DocsView.vue'),
  },
  {
    meta: { title: 'menu.generateVoucher' },
    path: '/generate',
    name: 'generate',
    component: async () => await import('@/views/voucher/CodeGenerate.vue'),
  },
  {
    meta: { title: 'menu.importMobile' },
    path:'/import-mobile',
    name:'import mobile',
    component: async () => await import('@/views/voucher/ImportMobile.vue'),
  },
]
